<template>
  <div class="ide-page">
    <header>
      <h1>全智模版IDE</h1>
      <ul>
        <li><el-button @click="save" size="mini" :disabled="isWorking.save">保存</el-button></li>
      </ul>
    </header>
    <IDE ref="ide" :template-id="templateId" :files="files" :props="props" />
  </div>
</template>

<script>
import IDE from '@/components/common/ide/index'
import { buildNewProp, buildNewFile } from '@/components/common/ide/utils'
import { fetchList } from '@/api/template/file'
import { save, fetchPropList } from '@/api/template/list'
import Constants from '@/components/common/ide/constants'

// 根目录
const rootFolder = {
  frontId: 'root',
  name: Constants.PROJECT_NAME,
  type: 'folder',
  fileNameExp: Constants.PROJECT_NAME,
  path: Constants.PROJECT_NAME
}
export default {
  name: 'IDEPage',
  components: { IDE },
  data () {
    return {
      isWorking: {
        save: false
      },
      // 模版ID
      templateId: null,
      // 文件列表
      files: [],
      // 属性列表
      props: []
    }
  },
  methods: {
    // 获取文件列表
    fetchFileList () {
      fetchList(this.templateId)
        .then(data => {
          this.files = data.map(file => {
            const templateFile = buildNewFile(file)
            templateFile.props = templateFile.props.map(p => {
              return buildNewProp(p)
            })
            return templateFile
          })
          this.files.unshift(rootFolder)
        })
        .catch(e => {
          this.$tip.apiFailed(e)
        })
    },
    // 获取属性列表
    fetchPropList () {
      fetchPropList(this.templateId)
        .then(data => {
          this.props = data.map(p => {
            return buildNewProp(p)
          })
        })
    },
    // 保存
    save () {
      if (this.isWorking.save) {
        return
      }
      this.isWorking.save = true
      save({
        templateId: this.templateId,
        props: this.props,
        files: this.$refs.ide.getTemplateFiles().filter(f => f.id == null || f.id < 0 || f.__isEdited)
      })
        .then(data => {
          // 为文件填充ID
          if (data.files.length > 0) {
            const templateFiles = this.$refs.ide.getTemplateFiles()
            for (const file of data.files) {
              const targetIndex = templateFiles.findIndex(f => f.frontId === file.frontId)
              const target = templateFiles[targetIndex]
              if (target == null) {
                continue
              }
              target.__isEdited = false
              // 新属性，赋值ID
              if (target.id == null) {
                target.id = file.id
              }
              // 已删除的文件，删除记录
              else if (target.id < 0) {
                this.files.splice(targetIndex, 1)
              }
            }
          }
          // 为属性填充ID
          if (data.props.length > 0) {
            for (const prop of data.props) {
              const targetIndex = this.props.findIndex(p => p.frontId === prop.frontId)
              const target = this.props[targetIndex]
              if (target == null) {
                continue
              }
              // 新属性，赋值ID
              if (target.id == null) {
                target.id = prop.id
              }
              // 已删除的属性，删除记录
              else if (target.id < 0) {
                this.props.splice(targetIndex, 1)
              }
            }
          }
        })
        .catch(e => {
          this.$tip.apiFailed(e)
        })
        .finally(() => {
          this.isWorking.save = false
        })
    }
  },
  created () {
    this.templateId = this.$route.params.id
    this.fetchFileList()
    this.fetchPropList()
  }
}
</script>

<style scoped lang="scss">
@import "../../components/common/ide/variables";
.ide-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  header {
    height: 40px;
    line-height: 40px;
    padding: 0 20px;
    background-color: #1d2627;
    font-weight: bold;
    color: #fff;
    display: flex;
    justify-content: space-between;
    ul {
      display: flex;
      .el-button {
        background-color: $primary-color;
        color: $color-white;
        border: 0;
        &:hover {
          background-color: $primary-color + 10;
        }
      }
    }
  }
  .ide {
    flex: 1;
    overflow: hidden;
  }
}
</style>
